import React, { Component } from "react";
import logoImg from 'assets/pro_funnel/logo.png';

const CONFIG = {
  documentTitle: "Get Started",
  logoSrc: logoImg,
  tagline: "Answer a few quick questions and we'll be in touch.",
  ctaLabel: "Get Started",
};

class ProLanding extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONFIG.documentTitle;
  }

  renderStyles() {
    return (
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .pl-root {
          font-family: 'Inter', sans-serif;
          min-height: 100vh;
          background: #fff;
          max-width: 480px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          padding: 0 24px 40px;
        }

        .pl-logo-wrap {
          padding: 36px 0 28px;
          display: flex;
          justify-content: center;
          border-bottom: 1px solid #EBF4FF;
        }

        .pl-logo {
          max-width: 140px;
          max-height: 72px;
          object-fit: contain;
        }

        .pl-body {
          flex: 1;
          display: flex;
          flex-direction: column;
          padding-top: 40px;
        }

        .pl-tagline {
          color: #1A3A5C;
          font-size: 22px;
          font-weight: 700;
          line-height: 1.4;
          margin-bottom: 12px;
        }

        .pl-sub {
          color: #4A6080;
          font-size: 15px;
          line-height: 1.6;
          margin-bottom: 40px;
        }

        .pl-cta {
          display: block;
          width: 100%;
          padding: 16px;
          background: #2B6CB0;
          color: #fff;
          font-size: 17px;
          font-weight: 600;
          font-family: 'Inter', sans-serif;
          border: none;
          border-radius: 12px;
          cursor: pointer;
          letter-spacing: 0.01em;
          transition: background 0.15s ease, transform 0.1s ease;
        }

        .pl-cta:hover { background: #1A3A5C; }
        .pl-cta:active { transform: scale(0.98); }

        @media (prefers-reduced-motion: reduce) {
          .pl-cta { transition: none; }
        }
      `}</style>
    );
  }

  render() {
    const search = this.props.location ? this.props.location.search : '';
    const quizUrl = `/pro/quiz${search}`;

    return (
      <div className="pl-root">
        {this.renderStyles()}
        <div className="pl-logo-wrap">
          <img src={CONFIG.logoSrc} alt="Logo" className="pl-logo" />
        </div>
        <div className="pl-body">
          <p className="pl-tagline">{CONFIG.tagline}</p>
          <p className="pl-sub">It only takes a minute. No resume needed.</p>
          <button className="pl-cta" onClick={() => this.props.history.push(quizUrl)}>
            {CONFIG.ctaLabel}
          </button>
        </div>
      </div>
    );
  }
}

export default ProLanding;
